import { auth } from '~/lib/firebase/auth'

export const firebaseRegLoginProvider = async (email: string) => {
  // TODO: error handling
  return await auth.fetchSignInMethodsForEmail(email)
}

export const firebaseUserExistanceCheck = async (email: string) => {
  const signInMethods = await firebaseRegLoginProvider(email)
  return signInMethods.length > 0
}

export const firebaseSigInProvider = {
  google: 'google.com',
  apple: 'apple.com',
  password: 'password',
}
